import React, { useEffect, useState } from "react";
import {useParams} from 'react-router-dom'
import { Github } from "../../services/github/service";
import UserDashboard from "../../components/users/userDashboard";

const User = () => {
    const {id} = useParams();
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [repos, setRepos] = useState([]);
    const [reposLoading, setReposLoading] = useState(false);
   
    useEffect(()=>{
        GetUserData();
        GetUserRepos();
    
    },[id])

    const GetUserData = async()=>{
        setLoading(true);
        const response = await Github.getUserInfo(id);
        setUser(response);
        setLoading(false);
    }
    const GetUserRepos = async()=>{
        setReposLoading(true);
        const response = await Github.getUserRepositories(id);
        setRepos(response);
        setReposLoading(false);
    }
    return (
            <UserDashboard loading={reposLoading|| loading} user={user} repos={repos} />
           
          
    );
}

export default User;